<template>
  <div class="cart-fixed-bottom" v-if="cart_items_count">
    <!-- <div class="cart-fixed-left">
      <h6>{{ cart_items_count }} {{ _T('items') }}</h6>
      <h5>{{ currency }} {{ Num.price(cart_sub_total) }}</h5>
    </div> -->
    <div
      id="open-cart"
      v-show="cart_items_count"
      class="cart-fixed-right"
      @click="navigateToCartPage()"
    >
      <h6>
        {{ _T('Cart') }} ({{ cart_items_count }})
        <svg width="16" height="14" fill="none">
          <use class="fill-white" :xlink:href="arrow_side" />
        </svg>
      </h6>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { eventBus } from '@/eventBus'
export default {
  computed: {
    ...mapGetters([
      'cart_items_count',
      '_T',
      'brandStoreRoute',
      'brandStoreParams',
      'cart_sub_total',
      'selectedDa',
      'order_type',
    ]),
  },
  data() {
    return {
      arrow_side: document.body.classList.contains('body-rtl')
        ? '#store-left-arrow'
        : '#rightarrow',
    }
  },
  //   mounted :{
  //     if (document.body.classList.contains('body-rtl') {

  //     }
  // )
  //   },
  methods: {
    navigateToCartPage() {
      if (!this.cart_items_count) {
        this.$store.dispatch('showNotification', {
          text: this._T('Please add some items in cart'),
          status: 'error',
        })
        return
      }
      this.$router.push({
        name: this.brandStoreRoute('cart'),
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.cart-fixed-bottom {
  display: none;
  position: fixed;
  bottom: $px20;
  background: $color-primary;
  box-shadow: 0px $px4 $px10 rgba($black, 0.3);
  border-radius: $px4;
  width: 70%;
  left: 60%;
  transform: translateX(-50%);
  padding: $px10;
  z-index: 3;
  .cart-fixed-left {
    h6 {
      font-size: $px12;
      line-height: $px15;
      letter-spacing: 0.5px;
      color: $white;
      margin-top: -$px3;
      margin-bottom: $px2;
    }
    h5 {
      font-style: normal;
      font-weight: 600;
      font-size: $px14;
      line-height: $px17;
      letter-spacing: 0.02em;
      color: $white;
      margin-bottom: -$px2;
    }
  }
  .cart-fixed-right {
    margin-left: auto;
    h6 {
      font-style: normal;
      font-weight: 600;
      font-size: $px14;
      line-height: $px17;
      text-align: right;
      letter-spacing: 0.02em;
      color: $white;
      margin-bottom: 0;
      text-transform: capitalize;
      svg,
      img {
        margin-left: $px8;
      }
    }
  }
  &.dine-in {
    bottom: $px100;
    width: auto;
    left: unset;
    right: 16%;
    transform: none;
  }
}
.mobile-fix-option {
  display: none;
}
@media (max-width: 767px) {
  .mobile-fix-option {
    position: fixed;
    bottom: 0;
    left: 0;
    height: $px60;
    background-color: $color-primary;
    width: 100vw;
    z-index: 4;
    padding: $px10;
    box-shadow: 0 $px2 $px5 0 $grey-3;
    display: flex;
    justify-content: space-around;
    .top {
      width: auto;
      height: $px22;
      margin: 0;
      &:focus {
        outline: none;
      }
      .mobile-option-icons {
        width: $px22;
        height: $px22;
      }
    }
    .mobile-menu {
      display: block;
      text-align: center;
      opacity: 0.7;
      .svg-size {
        width: $px20;
        height: $px20;
      }
      span {
        display: block;
        color: $white;
        font-size: $px12;
        line-height: $px15;
        letter-spacing: 0.02em;
        margin-top: $px5;
        text-transform: capitalize;
      }
      &.active {
        opacity: 1;
        span {
          font-weight: bold;
        }
      }
    }
  }
}
@media (max-width: 991px) {
  .cart-fixed-bottom {
    display: flex;
    align-items: center;
    width: 110px;
    left: 90%;
    bottom: 5%;
    height: 3rem;
  }
}
@media (max-width: 767px) {
  .cart-fixed-bottom {
    width: 110px;
    left: 83%;
    bottom: 7.5%;
    height: 3rem;
  }
}
.body-rtl {
  .cart-fixed-bottom {
    left: 39%;
    text-align: right;
    .cart-fixed-right {
      margin-right: auto;
      margin-left: unset;
      h6 {
        svg {
          margin-right: $px8;
        }
      }
    }
  }
  @media (max-width: 991px) {
    .cart-fixed-bottom {
      width: 70%;
    }
  }
}
</style>
